export default __webpack_public_path__ + "static/media/NodeJS-Logo.5a3a9ca2.svg";